import { OfferDisplayStatus } from '../constants/offer-display-status.enum';
import { OfferStatus } from '../constants/offer-status.enum';
import { OfferListItemResponseDto } from '../types/response';

type OfferState = Pick<OfferListItemResponseDto, 'status' | 'expiresAt' | 'archivedAt'>;

/** "Expired" is never stored – derived from `expiresAt`, like the backend list filter. */
export const getOfferDisplayStatus = (offer: Pick<OfferListItemResponseDto, 'status' | 'expiresAt'>, now: Date = new Date()): OfferDisplayStatus => {
  if (offer.status === OfferStatus.ACCEPTED) return OfferDisplayStatus.ACCEPTED;
  if (offer.status === OfferStatus.REVOKED) return OfferDisplayStatus.REVOKED;
  if (!offer.expiresAt) return OfferDisplayStatus.NOT_SENT;
  return new Date(offer.expiresAt) <= now ? OfferDisplayStatus.EXPIRED : OfferDisplayStatus.OPEN;
};

const SENDABLE = [OfferDisplayStatus.NOT_SENT, OfferDisplayStatus.OPEN, OfferDisplayStatus.EXPIRED];
const CLOSED = [OfferDisplayStatus.ACCEPTED, OfferDisplayStatus.REVOKED, OfferDisplayStatus.EXPIRED];

/** Drafts are sent, open and expired offers sent again (new link) – accepted, revoked and archived ones are final. */
export const canSendOffer = (offer: OfferState): boolean => !offer.archivedAt && SENDABLE.includes(getOfferDisplayStatus(offer));

/** Closed offers move to the read-only archive; drafts are deleted, open offers revoked first. */
export const canArchiveOffer = (offer: OfferState): boolean => !offer.archivedAt && CLOSED.includes(getOfferDisplayStatus(offer));

/** Until it is archived, an accepted offer is where its contract data is maintained. */
export const canCorrectOffer = (offer: OfferState): boolean => !offer.archivedAt && offer.status === OfferStatus.ACCEPTED;
